@if (_score) {
  <div class="flex">
    @for (s of stars; track $index) {
      @if (amazonStyle()) {
        @let svgSrc = s === Star.Half ? "amazon_star_half.svg" : "amazon_star.svg";
        <span><img [src]="'assets/img/' + svgSrc" /></span>
      } @else {
        <IIcon
          class="text-main-500"
          [name]="s === Star.Empty ? 'starOutline' : s === Star.Half ? 'starHalfFull' : 'starFilled'"
        />
      }
    }
  </div>
}
